import { DisconnectResolution } from "../../Store/Reducers/AssessmentSlice";
import { isUtcDateOverdue } from "../../Utils/Helper/assessmentDateUtils";

export const normalizeUserId = (id?: string | null): string =>
  String(id ?? "")
    .trim()
    .toLowerCase();

export const getLoggedInExecutiveId = (
  loggedInUser?: Record<string, unknown> | null
): string =>
  String(
    loggedInUser?.userId ??
      loggedInUser?.user_id ??
      loggedInUser?.executiveId ??
      ""
  ).trim();

const readPrimarySponsorId = (resolution: DisconnectResolution): string => {
  const record = resolution as DisconnectResolution & Record<string, unknown>;
  const value = record.primarySponsorId ?? record.primary_sponsor_id;
  return normalizeUserId(typeof value === "string" ? value : null);
};

const isPrimarySponsorForResolution = (
  resolution: DisconnectResolution,
  userId: string
): boolean => {
  const exec = normalizeUserId(userId);
  const primary = readPrimarySponsorId(resolution);
  if (!exec || !primary) return false;
  return exec === primary;
};

const isWithinDisconnectResolutionWindow = (
  resolution: DisconnectResolution
): boolean => !resolution.due_date || !isUtcDateOverdue(resolution.due_date);

export const canRecordDisconnectResolution = (
  resolution: DisconnectResolution,
  userId: string
): boolean => {
  if (resolution.status !== "pending_resolution") return false;
  if (!isWithinDisconnectResolutionWindow(resolution)) return false;
  return isPrimarySponsorForResolution(resolution, userId);
};

/** PS may change agreed level + justification until disconnect due (status resolved). */
export const canEditDisconnectResolution = (
  resolution: DisconnectResolution,
  userId: string
): boolean => {
  if (resolution.status !== "resolved") return false;
  if (!isWithinDisconnectResolutionWindow(resolution)) return false;
  return isPrimarySponsorForResolution(resolution, userId);
};
